import throttle from "./component-library150.mjs";
import Heading from "./component-library6.mjs";
import LinkButton from "./component-library3.mjs";
import ComparisonTableSlide from "./component-library64.mjs";
import Arrow from "./component-library4.mjs";
import ContentToggle from "./component-library61.mjs";
import "./component-library200.mjs";
import normalizeComponent from "./component-library92.mjs";
const _sfc_main = {
  name: "ComparisonTable",
  components: { Arrow, Heading, ComparisonTableSlide, LinkButton, ContentToggle },
  props: {
    headingTitle: { type: String, default: "" },
    headingTag: { type: String, default: "h2" },
    subTitle: { type: String, default: "" },
    subTag: { type: String, default: "h3" },
    data: { type: Array, required: true }
  },
  data() {
    return {
      showArrows: false,
      showTableValues: false,
      srAnnouncement: "",
      resizeHandler: throttle(this.shouldShowArrow, 1e3)
    };
  },
  computed: {
    hasAlternativesProducts() {
      return this.data.some((key) => key.productsBig);
    },
    featureList() {
      var _a, _b;
      return ((_b = (_a = this.data) == null ? void 0 : _a[0].values) == null ? void 0 : _b.map((feature) => feature.title)) || [];
    }
  },
  mounted() {
    window.addEventListener("resize", this.resizeHandler);
    this.shouldShowArrow();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  methods: {
    shouldShowArrow() {
      if (!this.$refs.scroller)
        return;
      this.showArrows = this.$refs.scroller.scrollWidth > this.$refs.scroller.offsetWidth;
    },
    scrollTable(direction) {
      const slideEl = this.$refs.scroller.firstChild;
      const columnWidth = (slideEl == null ? void 0 : slideEl.clientWidth) || 300;
      const sign = direction === "next" ? 1 : -1;
      this.$refs.scroller.scrollBy({
        left: sign * columnWidth,
        behavior: "smooth"
      });
    },
    clickHideTable() {
      this.showTableValues = !this.showTableValues;
      this.srAnnouncement = this.showTableValues ? "Die Tabelle wurde erweitert." : "Die Tabelle wurde eingeklappt.";
      if (this.showTableValues) {
        this.$nextTick(() => {
          const firstTableCell = this.$el.querySelector('[role="cell"]');
          if (firstTableCell) {
            const focusableElement = firstTableCell.querySelector(
              'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            if (focusableElement) {
              focusableElement.focus();
            } else {
              firstTableCell.setAttribute("tabindex", "0");
              firstTableCell.focus();
              setTimeout(() => {
                firstTableCell.setAttribute("tabindex", "-1");
              }, 150);
            }
          }
        });
      }
      setTimeout(() => {
        this.srAnnouncement = "";
      }, 1e3);
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "comparison-table", attrs: { "role": "table", "aria-label": "Produktvergleich" } }, [_vm.headingTitle ? _c("Heading", { staticClass: "comparison-table__title", attrs: { "tag": _vm.headingTag, "font-weight": "ultra", "size": "lg", "align": "center", "text-uppercase": "" } }, [_vm._v(" " + _vm._s(_vm.headingTitle) + " ")]) : _vm._e(), _vm.subTitle ? _c("Heading", { staticClass: "comparison-table__sub-title", attrs: { "tag": _vm.subTag, "size": "sm", "font-weight": "normal", "align": "center" } }, [_vm._v(" " + _vm._s(_vm.subTitle) + " ")]) : _vm._e(), _c("div", { staticClass: "comparison-table__slides-wrapper" }, [_vm.showArrows ? _c("Arrow", { staticClass: "comparison-table__arrow comparison-table__arrow--prev", attrs: { "aria-label": "Scrolle zur vorherigen Spalte", "set-position": "" }, on: { "change": function($event) {
    return _vm.scrollTable("prev");
  } } }) : _vm._e(), _c("div", { ref: "scroller", staticClass: "comparison-table__slides", class: { "comparison-table__slides--active": _vm.showArrows }, attrs: { "role": "rowgroup" } }, [_c("div", { staticClass: "comparison-table__row", attrs: { "role": "row" } }, _vm._l(_vm.data, function(item, index) {
    return _c("ComparisonTableSlide", { key: `header-${index}`, ref: "slideElement", refInFor: true }, [_c("div", { attrs: { "role": "columnheader", "aria-label": _vm.data.title } }, [_c("Heading", { staticClass: "comparison-table__product-title", attrs: { "tag": item.headingTag || "h2", "size": "sm", "font-weight": "ultra" } }, [_vm._v(" " + _vm._s(item.title) + " ")])], 1), _vm._t("header", null, { "data": item, "sameHeight": _vm.hasAlternativesProducts })], 2);
  }), 1), _c("ContentToggle", { attrs: { "show-content": _vm.showTableValues } }, [_vm._l(_vm.featureList, function(feature, rowIndex) {
    return _c("div", { key: `feature-${rowIndex}`, staticClass: "comparison-table__row", attrs: { "role": "row" } }, _vm._l(_vm.data, function(item, colIndex) {
      return _c("ComparisonTableSlide", { key: `cell-${rowIndex}-${colIndex}`, staticClass: "comparison-table__column", attrs: { "role": "cell" } }, [_vm._t("cell", null, { "feature": feature, "featureList": _vm.featureList, "item": item, "contentToggle": _vm.showTableValues, "sameHeight": _vm.hasAlternativesProducts })], 2);
    }), 1);
  }), _c("div", { staticClass: "comparison-table__row comparison-table__footer-row", attrs: { "role": "row" } }, _vm._l(_vm.data, function(item, index) {
    return _c("ComparisonTableSlide", { key: `footer-${index}`, staticClass: "comparison-table__column", attrs: { "role": "cell" } }, [_vm._t("footer", null, { "data": item, "index": index, "sameHeight": _vm.hasAlternativesProducts })], 2);
  }), 1)], 2)], 1), _vm.showArrows ? _c("Arrow", { staticClass: "comparison-table__arrow comparison-table__arrow--next", attrs: { "aria-label": "Scrolle zur nächsten Spalte", "direction": "right", "set-position": "" }, on: { "change": function($event) {
    return _vm.scrollTable("next");
  } } }) : _vm._e()], 1), _c("div", { staticClass: "comparison-table__hide-table" }, [_c("LinkButton", { attrs: { "tag": "button", "type": "button", "outline": "" }, on: { "click": _vm.clickHideTable } }, [_vm._v(" Features "), _vm.showTableValues ? _c("span", { attrs: { "data-testId": "hide" } }, [_vm._v("ausblenden")]) : _c("span", { attrs: { "data-testId": "show" } }, [_vm._v("einblenden")])])], 1), _c("div", { staticClass: "comparison-table__sr-announcement", attrs: { "aria-live": "polite", "aria-atomic": "true" } }, [_vm._v(" " + _vm._s(_vm.srAnnouncement) + " ")])], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "6af11bd7",
  null,
  null
);
const comparisonTable = __component__.exports;
export {
  comparisonTable as default
};
